import {useContext, useState, useEffect} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {OAUTH, IAM_SERVER_TENANT_USER} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from './InviteProfileSelectModal.module.css';
import EditModal from "../../Account/commponet/modal/EditModal";


/**
 * 테넌트 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
const DEFAULT_IMG = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export default function InviteProfileSelectModal({tenantId, unifiedProfileId, onComplete}) {

    const [profiles, setProfiles] = useState([]);
    const [selectedIdx, setSelectedIdx] = useState(null);

    useEffect(() => {
        axios.get(OAUTH + "/userinfo").then((res) => {
            setProfiles(res.data.sub_profile || []);
        });
    }, []);

    const handleTenantInvite = (selectedProfile) =>{
        
        const tenantUserParams = {
            tenantId: tenantId, // 실제 생성 후 ID 넣기
            profileId: selectedProfile.profile_id, // ✅ 여기서 사용
            unifiedProfileId: unifiedProfileId,
            tenantType: "user",
            userInfo: {},
        };

        // 테넌트 참가 유저 프로필 
        const url = IAM_SERVER_TENANT_USER + "/create";
        axios.post(url, tenantUserParams)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, "성공", res.data.message, onComplete);
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }


  return (
    <>
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h3 className={styles.title}>테넌트에서 사용할 프로필 선택</h3>

       
                <div className={styles.profileList}>
                    <div className={styles.infoBox}>
                        <p>선택한 프로필이 해당 테넌트에 가입됩니다.</p>
                    </div>
                    {profiles.map((profile, idx) => (
                        <div
                        key={idx}
                        className={`${styles.profileItem} ${selectedIdx === idx ? styles.selected : ""}`}
                        onClick={() => setSelectedIdx(idx)}
                        >
                        <div className={styles.profileImage}>
                            <img src={profile.image_url || DEFAULT_IMG} alt="profile" />
                        </div>
                        <div className={styles.profileName}>
                            {profile.profile_name || `프로필 ${idx + 1}`}
                        </div>
                        </div>
                    ))}
                </div>

                {selectedIdx !== null && (
                <button
                    className={styles.confirmButton}
                    onClick={() => handleTenantInvite(profiles[selectedIdx])}
                >
                    {profiles[selectedIdx].profile_name || "프로필"} 사용
                </button>
                )}
            </div>
        </div>
    </>
  );
}